import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import(/* webpackChunkName: "home" */ '@/views/Home.vue'),
    meta: { title: 'home' },
    redirect: '/survey/'
  }, {
    path: '/survey/',
    name: 'FeedBack',
    component: () => import(/* webpackChunkName: 'feedback' */ '@/views/feedback/index.vue'),
    meta: { title: 'feedback' }
  }, {
    path: '/survey/success',
    name: 'FeedBackSuccess',
    component: () => import(/* webpackChunkName: 'feedback' */ '@/views/feedback/success.vue'),
    meta: { title: 'feedback' }
  }, {
    path: '/survey/fail',
    component: () => import(/* webpackChunkName: 'feedback' */ '@/views/feedback/fail.vue'),
    meta: { title: 'feedback' }
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  scrollBehavior(to, from, savedPosition) {
    // 页面跳转时是否需要滚动
    // to 去往路由 from 来时路由 savePosition 记录滚动条位置
    // to from savaPosition 都是对象
    if (savedPosition) {
      return savedPosition;
    } else {
      return {
        top: 0,
        left: 0,
      };
    }
  },
  routes,
});

router.beforeEach((to, from, next) => {
  next();
});

export default router
